"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tagVars = exports.tagCommon = exports.default = void 0;
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _createPolymorphicComponent = require("../../utils/createPolymorphicComponent");
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var tagCommon = exports.tagCommon = _commonProps.defaultCommonProps;
var tagVars = exports.tagVars = (0, _initVars.default)({
  applied: tagCommon,
  variables: [{
    key: "fontColor",
    canHaveColor: true
  }, {
    key: "mainColor",
    canHaveColor: true
  }, {
    key: "fontColor60",
    canHaveColor: true
  }, {
    key: "fontColor90",
    canHaveColor: true
  }, {
    key: "mainColor30",
    canHaveColor: true
  }, {
    key: "mainColor50",
    canHaveColor: true
  }, {
    key: "mainColor60",
    canHaveColor: true
  }, {
    key: "mainColor80",
    canHaveColor: true
  }, {
    key: "defaultBorder",
    canHaveColor: true
  }, {
    key: "textTransform"
  }]
});
var tagStyles = function tagStyles(theme) {
  return {
    variables: tagVars.styles,
    root: _objectSpread(_objectSpread({}, _createPolymorphicComponent.polymorphicStyles), {}, {
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      padding: [Math.floor(theme.typography.fontSize / 4), theme.spacing.base / 2],
      color: tagVars.get("fontColor"),
      fontFamily: theme.typography.fontFamily,
      backgroundColor: tagVars.get("mainColor"),
      borderRadius: 2,
      lineHeight: "normal",
      "& svg": {
        fill: tagVars.get("fontColor")
      },
      textTransform: tagVars.get("textTransform")
    }),
    small: {
      fontSize: 12
    },
    medium: {
      fontSize: 14
    },
    large: {
      fontSize: 16
    },
    icon: {
      display: "flex",
      paddingInlineEnd: theme.spacing.base / 2
    },
    children: {
      display: "flex",
      padding: [0, theme.spacing.base / 2],
      overflow: "hidden",
      whiteSpace: "nowrap",
      "& > *": {
        color: tagVars.get("fontColor")
      }
    },
    count: {
      color: tagVars.get("fontColor90"),
      paddingInlineEnd: theme.spacing.base / 4
    },
    close: {
      all: "unset",
      cursor: "pointer",
      display: "flex",
      paddingInlineStart: theme.spacing.base / 2,
      "& svg": {
        backgroundColor: tagVars.get("fontColor60"),
        borderRadius: theme.iconSizes.large,
        fill: tagVars.get("mainColor"),
        "&:hover, &:focus-visible": {
          backgroundColor: tagVars.get("fontColor")
        }
      }
    },
    translucent: {
      fontWeight: 600,
      color: tagVars.get("mainColor"),
      backgroundColor: tagVars.get("mainColor30"),
      "& svg": {
        fill: tagVars.get("mainColor")
      }
    },
    translucentChildren: {
      "& > *": {
        color: tagVars.get("mainColor")
      }
    },
    translucentCount: {
      color: tagVars.get("mainColor80")
    },
    translucentClose: {
      "& svg": {
        backgroundColor: tagVars.get("mainColor30"),
        "&:hover, &:focus-visible": {
          backgroundColor: tagVars.get("mainColor60")
        }
      }
    },
    compact: {
      backgroundColor: "transparent",
      color: theme.colors.baseContrast070,
      "& svg": {
        fill: tagVars.get("mainColor")
      }
    },
    compactIcon: {},
    compactCount: {
      color: theme.colors.baseContrast060,
      paddingInlineEnd: theme.spacing.base / 4
    },
    compactClose: {
      "& svg": {
        backgroundColor: "transparent",
        fill: theme.colors.baseContrast070,
        "&:hover, &:focus-visible": {
          backgroundColor: "transparent",
          fill: theme.colors.baseContrast100
        }
      }
    },
    transluecentCompact: {
      color: tagVars.get("mainColor")
    },
    transluecentCompactColse: {
      "& svg": {
        backgroundColor: "transparent",
        fill: tagVars.get("mainColor50"),
        "&:hover, &:focus-visible": {
          backgroundColor: "transparent",
          fill: tagVars.get("mainColor")
        }
      }
    },
    border: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: tagVars.get("mainColor"),
      padding: [Math.floor(theme.typography.fontSize / 4) - 1, theme.spacing.base - 1]
    },
    defaultBorder: {
      borderColor: tagVars.get("defaultBorder")
    },
    backgroundOpacityClose: {
      "& svg": {
        background: "none",
        fill: tagVars.get("fontColor"),
        "&:hover, &:focus-visible": {
          background: "none",
          fill: tagVars.get("fontColor")
        }
      }
    }
  };
};
var useTagStyles = (0, _createUseStyles.default)(tagStyles, {
  name: "Tag"
});
var _default = exports.default = useTagStyles;